<template>
  <div class="small-12 columns">
    <div class="alpha-detail__row">
      <div class="alpha-detail__header">
        <ElButton type="text" class="alpha-detail__back-btn" @click="goBack">
          <i class="material-icons">arrow_forward</i>
        </ElButton>
        <h2 class="alpha-detail__title">{{ groupName }}</h2>
      </div>
      <ElButton
        type="default"
        size="small"
        class="alpha-detail__edit-btn"
        @click="handleEdit"
      >
        ویرایش
      </ElButton>
    </div>

    <AddAlphaGroupModal
      ref="alphaGroupModal"
      v-model="showAddAlphaGroupModal"
      :package-name="packageName"
      :group-id="groupId"
      :default-group-name="groupName"
    />
    <AlphaDetailTable :data="groupReleaseMember" @delete="deleteMember" />
  </div>
</template>

<script>
import AddAlphaGroupModal from './AddAlphaGroupModal.vue';
import packageName from '@/mixins/packageName';
import { mapActions, mapGetters } from 'vuex';
import {
  GROUP_RELEASE_MEMBER,
  GROUP_RELEASE_BY_ID,
  REMOVE_GROUP_MEMBER,
} from '@/store/types';
import AlphaDetailTable from './AlphaDetailTable.vue';
export default {
  name: 'AlphaDetail',
  components: {
    AddAlphaGroupModal,
    AlphaDetailTable,
  },
  mixins: [packageName],

  data() {
    return {
      showAddAlphaGroupModal: false,
      groupName: '',
    };
  },
  computed: {
    ...mapGetters({
      groupReleaseMember: GROUP_RELEASE_MEMBER,
      groupReleases: GROUP_RELEASE_BY_ID,
    }),
    groupId() {
      return this.$route.params.groupId;
    },
  },
  created() {
    this.loading = true;
    this.initialData();
  },
  methods: {
    ...mapActions({
      getReleaseMemberById: GROUP_RELEASE_MEMBER,
      getGroupReleaseById: GROUP_RELEASE_BY_ID,
      removeMember: REMOVE_GROUP_MEMBER,
    }),
    initialData() {
      this.getReleaseMemberByIdFnc();
      this.getGroupReleaseByIdFnc();
      this.loading = false;
    },
    async getReleaseMemberByIdFnc() {
      await this.getReleaseMemberById({
        packageName: this.packageName,
        id: this.groupId,
      });
    },
    async getGroupReleaseByIdFnc() {
      await this.getGroupReleaseById({
        packageName: this.packageName,
        id: this.groupId,
      });
      this.groupName = this?.groupReleases?.name;
    },
    handleEdit() {
      this.showAddAlphaGroupModal = true;
    },
    async deleteMember(member) {
      try {
        await this.$confirm(
          `آیا از حذف  عضو "${member}" اطمینان دارید؟`,
          'تأیید حذف',
          {
            confirmButtonText: 'حذف',
            cancelButtonText: 'انصراف',
            type: 'warning',
            confirmButtonClass: 'el-button--danger',
          },
        );

        await this.removeMember({
          packageName: this.packageName,
          id: this.groupId,
          phone_number: member,
        });

        this.$message.success(`عضو "${member}" با موفقیت حذف شد`);
      } catch (error) {
        if (error === 'cancel') {
          this.$message.info('عملیات حذف لغو شد');
        } else {
          this.$message.error('خطا در حذف گروه');
        }
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.alpha-detail {
  &__row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
  &__header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1rem;
    padding: 1rem 0;
  }
  &__back-btn {
    padding: 0rem;
    min-height: auto;
    .material-icons {
      font-size: 24px;
      color: #606266;
    }
  }
  &__title {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #303133;
  }
  &__edit-btn {
    border: 1px solid #dcdfe6;
    color: #606266;
    height: fit-content;
    &:hover {
      border-color: #409eff;
      color: #409eff;
    }
  }
}
</style>
